import { useCallback } from 'react';

import { Product } from 'src/utils/helpers/product';
import { useAddToCartModal } from 'src/components/modals/add-to-cart';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { tracker } from 'src/utils/analytics';
import {
  ProductRecommendationSection,
  ProductRecommendationSource,
} from 'src/utils/analytics/trackers/internal-gtm-tracker/internal-gtm-tracker.types';

type SetInternalTrackerContextArgs = {
  index: number;
  trackerSection: ProductRecommendationSection;
};

type UseProductCarouselReturn = {
  handleAddToCart: (product: Product) => Promise<void>;
  setInternalTrackerContext: (args: SetInternalTrackerContextArgs) => void;
};

export function useProductCarousel(): UseProductCarouselReturn {
  const { dispensary } = useDispensary();
  const { open: openAddToCartModal } = useAddToCartModal();

  const handleAddToCart = useCallback(
    async (product: Product) => {
      void openAddToCartModal({ product, dispensary });
    },
    [dispensary, openAddToCartModal]
  );

  function setInternalTrackerContext({ index, trackerSection }: SetInternalTrackerContextArgs): void {
    tracker.setContext({
      activeProductPosition: {
        fromCarousel: true,
        index,
        section: trackerSection,
        source: ProductRecommendationSource.native,
      },
    });
  }

  return { handleAddToCart, setInternalTrackerContext };
}
